import { render, staticRenderFns } from "./TipoServicoList.vue?vue&type=template&id=c81c56fa&scoped=true"
import script from "./TipoServicoList.vue?vue&type=script&lang=js"
export * from "./TipoServicoList.vue?vue&type=script&lang=js"
import style0 from "./TipoServicoList.vue?vue&type=style&index=0&id=c81c56fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81c56fa",
  null
  
)

export default component.exports